import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Notfound from "./components/Notfound/Notfound";
import Login from "./qcr-auth/Login/Login";
import ResetPassword from "./qcr-auth/ResetPassword/ResetPassword";
import ForgotPassword from "./qcr-auth/ForgotPassword/ForgotPassword";
import { Layout } from "./utils/Layout";
import {
  AdminRoutes,
  CustomerRoutes,
  InvestigatorRoutes,
  QARoutes
} from "./utils/Routes";
import ApplicantForm from "./qcr-common/ApplicantForm";
import InvestigatorReport from "./qcr-common/InvestigatorReport";
import ViewInvoice from "./qcr-customer/Invoices/ViewInvoice";
import ThankYou from "./components/ThankYou/ThankYou";
import { useDispatch } from "react-redux";
import { GetLocalUser } from "./qcr-auth/slices/authLocal";
import { loginSuccess } from "./qcr-auth/slices/authSlice";

function App() {
  const dispatch = useDispatch();
  const token = GetLocalUser().usertoken;
  if (
    token !== undefined &&
    token !== "undefined" &&
    token !== null &&
    token !== ""
  ) {
    dispatch(loginSuccess(GetLocalUser()));
  }
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route path="*" element={<Notfound />} />
            <Route element={<Layout showHeaderPaths={["/customer"]} />}>
              <Route exact path="/" element={<Login />}></Route>
              <Route exact path="/ResetPassword" element={<ResetPassword />} />
              <Route
                exact
                path="/ForgotPassword"
                element={<ForgotPassword />}
              />
              <Route path="/Form" element={<ApplicantForm />} />
              {/* <Route path="/HistoricReport" element={<HistoricalReports />}/> */}
              <Route path="/ThankYou" element={<ThankYou/>}/>
              <Route path="/Report" element={<InvestigatorReport />} />
              <Route path="/Invoice" element={<ViewInvoice />} />
              <Route path="/Admin/*" element={<AdminRoutes />} />
              <Route path="/Customer/*" element={<CustomerRoutes />} />
              <Route path="/Investigator/*" element={<InvestigatorRoutes />} />
              <Route path="/QA/*" element={<QARoutes/>} />
            </Route>
          </Routes>
        </Router>
    </div>
  );
}

export default App;
